import {Button} from '@logistics-frontend/blocks/lpc/button'
import {Typographyv2 as Typography} from '@logistics-frontend/blocks/v2'
import {useI18n} from '@logistics-frontend/core/i18n'
import {AuthStatus, StartupResponse} from '@yandex-taxi/js-integration-api'
import {useAuthorizationState} from '@yandex-taxi/react-integration-api'
import React from 'react'

import {useConfig} from 'src/config'

import {usePassportGoalCallback} from '../metrika'
import {classes} from './AuthorizationButton.classes'

type Props = {
  children: () => React.ReactElement
}

const AuthorizationButton: React.FC<Props> = ({children}) => {
  const t = useI18n()
  const status = useAuthorizationState<StartupResponse>()?.data?.authorization_status || AuthStatus.UNAUTHORIZED
  const signInGoal = usePassportGoalCallback('SignIn')
  const confirmPhoneGoal = usePassportGoalCallback('ConfirmPhone')
  const config = useConfig()

  if (status === AuthStatus.UNAUTHORIZED) {
    return (
      <Button color="primary" href={config.passport.registrationURL} onClick={signInGoal} variant="contained" fullWidth>
        <Typography className={classes.ld} thickness="regular" variant="body2">
          {t('order.form.authorization.registration_big', 'Зарегистрироваться и продолжить')}
        </Typography>
        <Typography className={classes.sm} thickness="regular" variant="body2">
          {t('order.form.authorization.registration_small', 'Зарегистрироваться')}
        </Typography>
      </Button>
    )
  }

  if (status === AuthStatus.PHONE_CONFIRMATION_REQUIRED) {
    return (
      <Button color="primary" href={config.passport.phonesURL} onClick={confirmPhoneGoal} variant="contained" fullWidth>
        {t('order.form.authorization.verify_phone_number', 'Подтвердить номер телефона')}
      </Button>
    )
  }

  return children()
}

export default AuthorizationButton
